/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { axios } from '~/util/http/axioshttp';
import { queryOptions } from '@tanstack/react-query';
import type { PatientContactsViewModel } from './PatientContactsViewModel'; 

export function getPatientContactsOptions(stayId: string, onSuccess?: (result: PatientContactsViewModel) => void) {
	return queryOptions({
		queryKey: ['patient-contacts', stayId],
		queryFn: async () => {
			const url = '/_api/v1/homehealth/demographics/contacts/queries/getpatientcontacts/' + stayId;
			const resp = await axios.get<PatientContactsViewModel>(url);
			if(onSuccess) {
				onSuccess(resp.data);
			}
			return resp.data;
		},
        enabled: Boolean(stayId)
	});
}